import React from 'react';
import { IProps } from './types';
import { Link } from 'react-router-dom';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import * as Yup from 'yup';
import { Formik, Form, Field, FieldArray, getIn, ErrorMessage } from 'formik';
import { setGuardianshipStatementModalVisibleAction } from 'redux/actions/modal.action';
import Accordion from 'components/Accordion';
import _ from 'lodash';
import { TravelWarning, TravelCountryContent, SysOption, SysOptionReq, FlightInfoResp, Flight, FlightWithStatus } from 'bff/models/info';
import { Link as LinkModel } from 'bff/models/link';
import { WarnStatus } from 'constants/enums/warnStatus.enum';
import sweetAlertService from 'utils/sweetAlertService';
import commonService from 'utils/commonService';
import apiCommonService from 'bff/services/commonService';
import service from 'bff/services/travelProductService';
// import PDFViewer from 'components/PDFViewer';
import { ExpanBodyContent, ExpanBodyBaseContent, ExpanFooterContent, EvalExpans } from 'constants/models/evalExpans';
import { EvalInfoBodyType } from 'constants/enums/evalIfnoBodyType.enum';
import moment from 'moment-timezone';
import { Transport } from 'constants/enums/transport.enum';
import { YesNo } from 'constants/enums/yesNo.enum';
import { DatePicker } from 'formik-antd';
import { CodeId } from 'constants/enums/codeId.enum';
import { EvalReq } from 'bff/models/product';
import { SysOptType } from 'constants/enums/sysOptType.enum';
import { SysOptParamId } from 'constants/enums/sysOptParamId.enum';
import { ICalcFormValue } from 'constants/models/components/insurProcess/insureProcessCalc';
import { IFill1stFormValue, FlightInfo, IFill1stState, TravelWarningExpandData, Contract } from 'constants/models/components/insurProcess/insureProcessFill1st';
import { SweetAlertIcon } from 'constants/enums/sweetAlertIcon.enum';
import InputWithRegex from 'components/InputWithRegex';
import { NumAndEnglishRegex } from 'utils/commonValidations';
import { GeoAreaId } from 'constants/enums/geoAreaId.enum';
import { TravelPlanType } from 'constants/enums/travelPlanType.enum';
import { TravelSchengen } from 'constants/enums/travelSchengen.enum';
import { InsuredState } from 'constants/models/components/insurProcess/insureProcessFill2nd';
import { InsCount } from 'constants/enums/insCount.enum';
import { InsureSubject } from 'constants/enums/insureSubject.enum';
import FormikFocusError from 'components/FormikFocusError';
import Fold from 'components/Fold';
import { ReturnCode } from 'constants/enums/returnCode.enum';
import PDFAllPageViewer from 'components/PDFAllPageViewer';
import { ExclamationCircleOutlined } from '@ant-design/icons';

const initVal: IFill1stFormValue = {
  DECLARED: '',
  TOURIST_DESTINATION: '',
  TOURIST_COUNTRY: '',
  // TOURIST_MOUNTAIN: '',
  TRANSPORT: Transport.Other,
  PROVIDE_INFO: 'N',
  FLIGHT_INFOS: [
    { FDATE: new Date().toDateString(), CARRIER_ID: '', FLIGHT_NO: '', SEARCH_RESULT: [] },
    { FDATE: new Date().toDateString(), CARRIER_ID: '', FLIGHT_NO: '', SEARCH_RESULT: [] }
  ],
  CONTRACTS: new Array(0),
  ALL_CONTRACT_CHECKED: false
};

const initState: IFill1stState = {
  programSummaryVisible: false,
  programSummaryDetailsOpen: false,
  insuranceInfoProgramDetailsOpen: false,
  claimsServiceNotesOpen: true,
  activeTouristArea: '',
  tempTravels: new Array(0),
  travelWarnings: new Array(0),
  showQuickClaim: false,
  showAirPlaneInfo: false,
  isDeclared: false,
  editedTempCalc: {},
  transportSysOpts: new Array(0),
  yesnoSysOpts: new Array(0),
  travelPeriod: 0,
  showInsuredTime: false,
  termStatus: new Array(0),
  detailFoldsOpen: new Array(0),
  sysTime: 0,
  claimsServiceNotesElemHeight: 0
};

let initialValues: IFill1stFormValue = initVal;
let isTravelBubble = false;

class InsureProcessFill1st extends React.PureComponent<IProps, IFill1stState> {
  private insuranceInfoFormRef = React.createRef() as React.RefObject<HTMLDivElement>;
  private insuranceInfoProgramDetailsRef = React.createRef() as React.RefObject<HTMLDivElement>;
  private claimsServiceNotesRef = React.createRef() as React.RefObject<HTMLOListElement>;
  private formikRef: any = React.createRef();

  readonly state: IFill1stState = initState

  componentDidMount = async () => {
    commonService.scrollToTop();
    this.addWindowScrollEvent();
    this.handleInitForm();
    await this.handleFetchSysOpts();
    this.handleInitData();
    this.handleInitTempData();
    this.handleSetTravelBubble();
    this.addWindowResizeEvent();
  }

  componentWillUnmount () {
    if (!this.formikRef || !this.formikRef.current) return;

    const formVal = this.formikRef.current.values;

    this.props.onUnmount(formVal, this.state);

    initialValues = {
      ...initVal
    };

    this.removeWindowScrollEvent();
    this.removeWindowResizeEvent();
  }

  componentDidUpdate (prevProps: Readonly<IProps>, prevState: Readonly<IFill1stState>): void {
    if (prevState.showQuickClaim !== this.state.showQuickClaim) {
      this.setClaimsServiceNotesElemHeight();
    }
  };

  /**
   * @description 設定理賠通知服務注意事項高度
   */

  setClaimsServiceNotesElemHeight = () => {
    this.setState(prev => ({
      ...prev,
      claimsServiceNotesElemHeight: this.handleGetClaimsAreaHeight()
    }));
  }

  /**
   * @description 設定旅遊泡泡資訊
   */
  handleSetTravelBubble = () => {
    isTravelBubble = false;

    const { planData } = this.props.tempCalc;

    if (!planData) return;

    const { PROD_ID } = planData;

    if (!PROD_ID || PROD_ID !== TravelPlanType.TBP) return;

    const travelInfo = _.find(this.state.travelWarnings,
      (travelInfo: TravelWarningExpandData) => travelInfo.GEOAREA_ID === GeoAreaId.AZ && travelInfo.COUNTRY_ID === 'PW');

    if (!travelInfo) return;

    // 提示警示訊息
    this.handleShwoTravelMsg(travelInfo);

    if (travelInfo.WARN_STATUS === WarnStatus.Orange) {
      apiCommonService.fetchSysTime().then((res: any) => {
        travelInfo.WARN_SELECT_TIME = res;
      });
    }

    isTravelBubble = true;

    initialValues = {
      ...initialValues as IFill1stFormValue,
      TOURIST_DESTINATION: travelInfo.GEOAREA_ID || '',
      TOURIST_COUNTRY: travelInfo.COUNTRY_ID || ''
    };

    const tempTravels: TravelWarningExpandData[] = new Array(0);
    tempTravels.push(travelInfo);

    this.setState(prevState => {
      return {
        ...prevState,
        tempTravels: tempTravels,
        activeTouristArea: travelInfo.GEOAREA_ID || ''
      };
    });
  }

  /**
   * @description 取得系統參數資料
   */
  handleFetchSysOpts = async () => {
    // 取得系統時間
    const serverTimeMs = await apiCommonService.fetchSysTime();
    const sysTime = Math.ceil(serverTimeMs / 1000);

    // 取得系統參數
    const sysOptionReq: SysOptionReq = {
      PCLASS: [SysOptType.TRANSPORT, SysOptType.YESNO, SysOptType.TRAVEL_PERIOD]
    };
    const res = await apiCommonService.fetchSysOpts(sysOptionReq);
    if (res) {
      const bgap = res.TRAVEL_PERIOD.find(it => it.PARAM_ID === SysOptParamId.BGAP);
      this.setState({
        transportSysOpts: commonService.sortSysOpts(commonService.arrayTypeReturn(res[SysOptType.TRANSPORT])),
        yesnoSysOpts: res[SysOptType.YESNO].sort((first: SysOption, second: SysOption) => {
          if (first.PARAM_ORDER && second.PARAM_ORDER) return second.PARAM_ORDER - first.PARAM_ORDER;

          return 0;
        }),
        travelPeriod: bgap ? +bgap.PARAM_VALUE : 7, // 取得旅平險網要進件日與生效日間隔天數，查不到則維持 7 天
        sysTime
      });
    }
  }

  /**
   * @description 初始化 State 資訊
  */
  handleInitData = () => {
    // 取得攤平後的旅遊地區資訊
    const travelWarningArray: TravelWarningExpandData[] = new Array(0);
    let tempTravels: TravelWarningExpandData[] = new Array(0);
    let activeTouristArea = '';

    if (this.props.travelWarnings && this.props.travelWarnings.length > 0) {
      const prodId = this.props.tempCalc?.planData?.PROD_ID;
      const isDomestic = prodId === TravelPlanType.Domestic || prodId === TravelPlanType.MPA || prodId === TravelPlanType.WPA;

      _.forEach(this.props.travelWarnings, (travelWarning: TravelWarning, index: number) => {
        _.forEach(travelWarning.COUNTRYS, (countrys: TravelCountryContent, index: number) => {
          const travelInfo: TravelWarningExpandData = {
            GEOAREA_ID: travelWarning.GEOAREA_ID,
            GEOAREA_NAME: travelWarning.GEOAREA_NAME,
            COUNTRY_ID: countrys.COUNTRY_ID,
            COUNTRY_NAME: countrys.COUNTRY_NAME,
            HOT_COUNTRY: countrys.HOT_COUNTRY,
            SCHENGEN: countrys.SCHENGEN,
            WARN_STATUS: countrys.WARN_STATUS,
            WARN_MSG: countrys.WARN_MSG
          };

          travelWarningArray.push(travelInfo);

          if (isDomestic && travelWarning.GEOAREA_ID === GeoAreaId.Domestic) {
            // 提示警示訊息
            this.handleShwoTravelMsg(travelInfo);

            if (travelInfo.WARN_STATUS === WarnStatus.Orange) {
              apiCommonService.fetchSysTime().then((res: any) => {
                travelInfo.WARN_SELECT_TIME = res;
              });
            }

            tempTravels.push(travelInfo);

            initialValues = {
              ...initialValues,
              TOURIST_DESTINATION: travelInfo.GEOAREA_ID || '',
              TOURIST_COUNTRY: travelInfo.COUNTRY_ID || ''
            };

            activeTouristArea = travelInfo.GEOAREA_ID || '';
          }
        });
      });
    }

    if (this.props.tempCalc && this.props.tempCalc.tempCalcFormVal) {
      const country = this.props.tempCalc.tempCalcFormVal.TOURIST_COUNTRY;
      const destination = this.props.tempCalc.tempCalcFormVal.TOURIST_DESTINATION;
      initialValues = {
        ...initialValues,
        TOURIST_COUNTRY: country,
        TOURIST_DESTINATION: destination
      };
      if (this.props.tempCalc.tempTravels) tempTravels = [...this.props.tempCalc.tempTravels];
      if (this.props.tempCalc.activeTouristArea) activeTouristArea = this.props.tempCalc.activeTouristArea;
    }

    const prodId = this.props.tempCalc?.tempCalcFormVal?.PROD_ID;
    const showQuickClaim =
      prodId === TravelPlanType.Abroad ||
      prodId === TravelPlanType.NTAG;

    this.setState(prevState => {
      return {
        ...prevState,
        travelWarnings: [...travelWarningArray],
        tempTravels: [...tempTravels],
        editedTempCalc: { ...this.props.tempCalc },
        activeTouristArea: activeTouristArea,
        showQuickClaim,
        termStatus: commonService.getInitTermStatus(this.props.docLinks)
      };
    });
  }

  /**
   * @description 初始化表單資料
  */
  handleInitForm = () => {
    console.log(this.props.tempCalc.tempCalcFormVal);
    if (this.props.tempCalc.tempCalcFormVal) {
      if (this.props.tempFill1st.tempFill1stFormVal) {
        if (this.props.tempFill1st.tempFill1stFormVal.TOURIST_COUNTRY === '' && this.props.tempFill1st.tempFill1stFormVal.TOURIST_DESTINATION === '') {
          initialValues = {
            ...initVal,
            START_DATE: moment(this.props.tempCalc.tempCalcFormVal.START_DATE),
            END_DATE: moment(this.props.tempCalc.tempCalcFormVal.END_DATE),
            INSURED_TIME: moment(this.props.tempCalc.tempCalcFormVal.INSURED_TIME),
            INSURE_PERIOD: this.props.tempCalc.evalReq?.INSURE_PERIOD,
            CONTRACTS: this.handleGetContracts(this.props.docLinks)
          };
        } else {
          initialValues = {
            ...initVal,
            START_DATE: moment(this.props.tempFill1st.tempFill1stFormVal.START_DATE),
            END_DATE: moment(this.props.tempFill1st.tempFill1stFormVal.END_DATE),
            INSURED_TIME: moment(this.props.tempFill1st.tempFill1stFormVal.INSURED_TIME),
            INSURE_PERIOD: this.props.tempFill1st.tempFill1stFormVal.INSURE_PERIOD,
            CONTRACTS: this.handleGetContracts(this.props.docLinks)
          };
        }
      } else {
        initialValues = {
          ...initVal,
          START_DATE: moment(this.props.tempCalc.tempCalcFormVal.START_DATE),
          END_DATE: moment(this.props.tempCalc.tempCalcFormVal.END_DATE),
          INSURED_TIME: moment(this.props.tempCalc.tempCalcFormVal.INSURED_TIME),
          INSURE_PERIOD: this.props.tempCalc.evalReq?.INSURE_PERIOD,
          CONTRACTS: this.handleGetContracts(this.props.docLinks),
          FLIGHT_INFOS: [
            { ...initVal.FLIGHT_INFOS[0], FDATE: this.props.tempCalc.tempCalcFormVal.START_DATE },
            { ...initVal.FLIGHT_INFOS[1], FDATE: this.props.tempCalc.tempCalcFormVal.END_DATE }
          ]
        };
      }
    }
  }

  /**
   * @description 如有暫存資料，讀取暫存資料
  */
  handleInitTempData = () => {
    if (this.props.tempCalc && this.props.tempCalc.tempCalcFormVal && this.props.tempFill1st && this.props.tempFill1st.tempFill1stState && this.props.tempFill1st.tempFill1stFormVal) {
      // 暫存的旅遊地區
      const country = this.props.tempCalc.tempCalcFormVal.TOURIST_COUNTRY;
      // 暫存的旅遊地點
      const destination = this.props.tempCalc.tempCalcFormVal.TOURIST_DESTINATION;
      const prodId = this.props.tempCalc.tempCalcFormVal.PROD_ID;
      const declared = this.props.tempFill1st.tempFill1stFormVal.DECLARED;
      // console.warn("🚀 ~ this.props.tempCalc:", this.props.tempCalc)
      // console.warn("🚀 ~ handleInitTempData ~ prodId:", prodId)
      // 判斷是否顯示快速理賠區塊
      const showQuickClaim =
        (prodId === TravelPlanType.Abroad ||
        prodId === TravelPlanType.NTAG) &&
        declared === YesNo.No;
      initialValues = {
        ...this.props.tempFill1st.tempFill1stFormVal as IFill1stFormValue,
        // 若無暫存的旅遊地區、為修改方案來的，取得前個方法設定的旅遊地區
        TOURIST_COUNTRY: country || initialValues.TOURIST_COUNTRY,
        // 若無暫存的旅遊地點、為修改方案來的，取得前個方法設定的旅遊地點
        TOURIST_DESTINATION: destination || initialValues.TOURIST_DESTINATION,
        // 依是否顯示快速理賠判斷是否提供航班資訊值，若無值設為 No
        PROVIDE_INFO: showQuickClaim ? this.props.tempFill1st.tempFill1stFormVal.PROVIDE_INFO : 'N'
      };
      if (this.props.tempFill1st.tempFill1stFormVal.TOURIST_COUNTRY === '' && this.props.tempFill1st.tempFill1stFormVal.TOURIST_DESTINATION === '') {
        if (this.props.tempCalc.tempCalcFormVal) {
          initialValues = {
            ...initialValues,
            START_DATE: moment(this.props.tempCalc.tempCalcFormVal.START_DATE),
            END_DATE: moment(this.props.tempCalc.tempCalcFormVal.END_DATE),
            INSURED_TIME: moment(this.props.tempCalc.tempCalcFormVal.INSURED_TIME)
          };
        }
      } else {
        initialValues = {
          ...initialValues,
          START_DATE: moment(this.props.tempFill1st.tempFill1stFormVal?.START_DATE),
          END_DATE: moment(this.props.tempFill1st.tempFill1stFormVal?.END_DATE),
          INSURE_PERIOD: moment(this.props.tempFill1st.tempFill1stFormVal?.END_DATE).diff(this.props.tempFill1st.tempFill1stFormVal?.START_DATE, 'd'),
          INSURED_TIME: moment(this.props.tempFill1st.tempFill1stFormVal?.INSURED_TIME)
        };
      }
      const tempTravels = this.props.tempCalc.tempTravels ? [...this.props.tempCalc.tempTravels] : [];
      const activeTouristArea = this.props.tempCalc.activeTouristArea;
      this.setState(preState => {
        return {
          ...this.props.tempFill1st.tempFill1stState,
          editedTempCalc: { ...this.props.tempCalc },
          tempTravels: tempTravels.length > 0 ? [...tempTravels] : [...preState.tempTravels],
          // 若無暫存的選取旅遊地區、取得前個方法設定的選取旅遊地區
          activeTouristArea: activeTouristArea || preState.activeTouristArea,
          // 依是否顯示快速理賠
          showQuickClaim: showQuickClaim,
          // 依是否顯示快速理賠設定是否顯示航班資訊
          showAirPlaneInfo: showQuickClaim ? this.props.tempFill1st.tempFill1stState?.showAirPlaneInfo as boolean : false
        };
      });
    }
  }

  /**
   * @description 取得要保人聲明事項初始值
  */
  handleGetContracts = (contractLinks: LinkModel[]) => {
    const res = new Array(0);
    if (contractLinks && contractLinks.length > 0) {
      _.forEach(contractLinks, (contractLink: LinkModel, index: number) => {
        res.push({
          LINK_NAME: contractLink.NAME,
          LINK_URL: contractLink.URL,
          CONTRACT: false
        });
      });
    }
    return res;
  }

  // 新增 window scroll 事件監聽
  addWindowScrollEvent = () => {
    window.addEventListener('scroll', this.toggleProgramSummaryVisible, false);
  }

  // 移除 window scroll 事件監聽
  removeWindowScrollEvent = () => {
    window.removeEventListener('scroll', this.toggleProgramSummaryVisible, false);
  }

  // 新增 window resize 事件監聽
  addWindowResizeEvent = () => {
    window.addEventListener('resize', () => this.setClaimsServiceNotesElemHeight());
  }

  //移除 window resize 事件監聽
  removeWindowResizeEvent = () => {
    window.removeEventListener('resize', () => this.setClaimsServiceNotesElemHeight());
  }

  // 開啟/關閉「投保資訊」方案詳細資訊
  handleInsuranceInfoProgramDetailsToggle = () => {
    this.setState(state => ({ ...state, insuranceInfoProgramDetailsOpen: !this.state.insuranceInfoProgramDetailsOpen }));
  }

  // 開啟/關閉「快速理賠服務」注意事項
  handleClaimsServiceNotesToggle = () => {
    this.setState(state => ({ ...state, claimsServiceNotesOpen: !this.state.claimsServiceNotesOpen }));
  }

  // 開啟/關閉 方案詳細資訊 (方案摘要區塊)
  handleProgramSummaryDetailsToggle = () => {
    this.setState(state => ({ ...state, programSummaryDetailsOpen: !this.state.programSummaryDetailsOpen }));
  }

  // 視窗滾動低於「投保資訊」區塊以下時，顯示「投保資訊」方案摘要區塊 (Fixed 在 Header 下方)
  toggleProgramSummaryVisible = () => {
    const headerHeight = 72;
    const InsuranceInfoFormoffsetTop = (window.pageYOffset + this.insuranceInfoFormRef.current!.getBoundingClientRect().top) - headerHeight;
    const scrollTopPosition = window.pageYOffset;

    this.setState(state => ({
      ...state,
      programSummaryVisible: (scrollTopPosition > InsuranceInfoFormoffsetTop)
    }));
  }

  // #region 旅遊地區相關方法

  /**
   * @description 選取旅遊地區，新增旅遊標籤資料
  */
  handleSetTravelTag = async (countryId: string) => {
    const travelInfo = _.find(this.state.travelWarnings, (travel: TravelWarningExpandData) => travel.COUNTRY_ID === countryId);

    // 已新增過的就不再新增
    let canUpdate = travelInfo && _.every(this.state.tempTravels, (travel: TravelWarningExpandData) => travel.COUNTRY_ID !== travelInfo.COUNTRY_ID);

    // 判斷是否已達 6 個
    canUpdate = canUpdate && this.state.tempTravels.length < 6;

    if (canUpdate && travelInfo) {
      // 提示警示訊息
      this.handleShwoTravelMsg(travelInfo);

      // 判斷旅遊警示是否為橙色，是，紀錄選取時間
      let warnSelectTime;
      if (travelInfo.WARN_STATUS === WarnStatus.Orange) {
        warnSelectTime = await apiCommonService.fetchSysTime();
      };

      travelInfo.WARN_SELECT_TIME = warnSelectTime;
      this.handleAddTempTravels(travelInfo);
    }
  }

  /**
   * @description 顯示選取得旅遊地區警示資訊
  */
  handleShwoTravelMsg = (travelInfo: TravelWarningExpandData) => {
    // 同時為橘色警戒國家、且有提示訊息
    if (travelInfo.WARN_STATUS === WarnStatus.Orange && travelInfo.WARN_MSG) {
      sweetAlertService.modal({
        html: '您選擇之旅遊地點為橘色警示國家，請確認'
      }).then(() => {
        sweetAlertService.modal({
          html: travelInfo.WARN_MSG
        });
      });

      return;
    }

    // 為橘色警戒國家
    if (travelInfo.WARN_STATUS === WarnStatus.Orange) {
      sweetAlertService.modal({
        html: '您選擇之旅遊地點為橘色警示國家，請確認'
      });
    }

    // 為有提示訊息
    if (travelInfo.WARN_MSG) {
      sweetAlertService.modal({
        html: travelInfo.WARN_MSG
      });
    }
  }

  /**
   * @description 新增選取的旅遊地點資訊，並移除錯誤訊息
  */
  handleAddTempTravels = (travelInfo: TravelWarningExpandData) => {
    const tempTravels = [...this.state.tempTravels];
    tempTravels.push(travelInfo);

    if (tempTravels.length > 0) {
      this.formikRef.current.setFieldError('TOURIST_DESTINATION', '');
      this.formikRef.current.setFieldError('TOURIST_COUNTRY', '');
    }

    this.setState({ tempTravels: [...tempTravels] });
  }

  /**
   * @description 移除旅遊標籤
   * @param areaId 地區 Id
   * @param countryId 城市 Id
   */
  handleRemoveTravelTag = (areaId: string, countryId: string) => {
    if (isTravelBubble) return;

    const removeIndex = _.findIndex(this.state.tempTravels, (travel: TravelWarningExpandData) =>
      travel.GEOAREA_ID === areaId && travel.COUNTRY_ID === countryId);

    const updateTempTravels = [...this.state.tempTravels];

    updateTempTravels.splice(removeIndex, 1);
    let activeTouristArea = this.state.activeTouristArea;
    if (updateTempTravels.length === 0) {
      this.formikRef.current.setFieldValue('TOURIST_DESTINATION', '');
      this.formikRef.current.setFieldValue('TOURIST_COUNTRY', '');
      activeTouristArea = '';
    }

    this.setState({ tempTravels: [...updateTempTravels], activeTouristArea: activeTouristArea });
  }

  // #endregion

  /**
   * @description 根據路徑下載檔案
  */
  handleDownloadFile = (event: React.MouseEvent<HTMLButtonElement>, linkUrl: string, fileName: string) => {
    event.stopPropagation();
    try {
      commonService.downloadFile(linkUrl, fileName);
    } catch {
      sweetAlertService.modal({
        icon: SweetAlertIcon.Info,
        title: '下載失敗',
        html: '無法取得相關資訊'
      });
    }
  };

  /**
   * @description 取得投保資訊區塊高度
  */
  handleGetProgramDetailsElemHeight = () => {
    if (this.insuranceInfoProgramDetailsRef && this.insuranceInfoProgramDetailsRef.current) {
      return this.insuranceInfoProgramDetailsRef.current!.clientHeight;
    }
    return 0;
  }

  /**
   * @description 交通工具切換事件
   */
  handleTransportChange = (e: React.ChangeEvent<HTMLSelectElement>, setFieldValue: any) => {
    // let showInfo = this.state.showAirPlaneInfo;
    // if (e.currentTarget.value !== Transport.Airplane) {
    //   setFieldValue('FLIGHT_INFOS', new Array(0));
    //   showInfo = false;
    // }
    // const prodId = this.props.tempCalc?.planData?.PROD_ID;
    // const showQuickClaim = e.currentTarget.value === Transport.Airplane &&
    //   prodId !== TravelPlanType.MPA &&
    //   prodId !== TravelPlanType.SPI &&
    //   prodId !== TravelPlanType.Domestic &&
    //   prodId !== TravelPlanType.WPA;

    // if (showQuickClaim) {
    //   setFieldValue('PROVIDE_INFO', YesNo.No);
    // }

    // this.setState({
    //   showQuickClaim: showQuickClaim,
    //   showAirPlaneInfo: showInfo
    // });
  }

  // #region 快速理賠相關方法區塊

  /**
   * @description 格式化快速理賠區塊 Title
  */
  handleGetClaimTitle = (str: string) => {
    return (
      <>
        {str.substring(0, 3)}<span>{str.substring(3, 7)}</span>{str.substring(7)}
      </>
    );
  };

  /**
   * @description 取得「快速理賠服務」注意事項 Element 高度
  */
  handleGetClaimsAreaHeight = () => {
    if (this.claimsServiceNotesRef && this.claimsServiceNotesRef.current) {
      return this.claimsServiceNotesRef.current!.clientHeight;
    }

    return 0;
  }

  /**
    * @description 切換是否填寫航班資訊
   */
  handleToggleShowAirPlaneInfo = async (showInfo: boolean, setFieldValue: any) => {
    if (!showInfo) {
      // setFieldValue('FLIGHT_INFOS', new Array(0));
      setFieldValue('PROVIDE_INFO_AGREE_TIME', 0);
    } else {
      const serverTimeMs = await apiCommonService.fetchSysTime();

      // setFieldValue('FLIGHT_INFOS', [{ FDATE: '', CARRIER_ID: '', FLIGHT_NO: '', SEARCH_RESULT: new Array(0) }]);
      setFieldValue('PROVIDE_INFO_AGREE_TIME', serverTimeMs);
    }

    this.setState(prev => ({
      ...prev,
      showAirPlaneInfo: showInfo
    }));
  }

  /**
   * @description 查詢航班資訊
   */
  handleSearchFlightInfo = async (index: number, values: IFill1stFormValue, setFieldValue: any, setFieldError: any, setFieldTouched: any) => {

    // 格式化查詢參數
    let flightDate = values.FLIGHT_INFOS[index].FDATE ?? '';
    if (flightDate) {
      flightDate = moment(flightDate).format('YYYYMMDD');
    }
    const carrierId = values.FLIGHT_INFOS[index].CARRIER_ID ?? '';
    const flightNo = values.FLIGHT_INFOS[index].FLIGHT_NO ?? '';
    // if (!flightDate) {
    //   setFieldError(`FLIGHT_INFOS[${index}].FDATE`, '此為必填欄位');
    //   setFieldTouched(`FLIGHT_INFOS[${index}].FDATE`);
    // }
    // if (!carrierId) {
    //   setFieldError(`FLIGHT_INFOS[${index}].CARRIER_ID`, '此為必填欄位');
    //   setFieldTouched(`FLIGHT_INFOS[${index}].CARRIER_ID`);
    // }
    // if (!flightNo) {
    //   setFieldError(`FLIGHT_INFOS[${index}].FLIGHT_NO`, '此為必填欄位');
    //   setFieldTouched(`FLIGHT_INFOS[${index}].FLIGHT_NO`);
    // }
    if (!flightNo || !carrierId || !flightDate) return;

    if (flightNo && carrierId && flightDate) {
      // 取得查詢結果
      const res: FlightInfoResp = await service.fetchFlightSchedule(flightDate, carrierId.toUpperCase(), flightNo);
      const flights = res.flights;
      // 無查詢錯誤進行查詢結果設值
      if (res.returnCode === ReturnCode.CodeSuccess) {
        if (flights.length === 1) {
          setFieldValue(`FLIGHT_INFOS[${index}].SEARCH_RESULT`, [...flights].map((f: Flight, i: number) => {
            if (index === 0 && (moment(f.departureTime) < moment(values.START_DATE?.format('YYYY-MM-DD') + ' ' + values.INSURED_TIME?.format('HH:mm:ss')) || moment(f.departureTime) > moment(values.END_DATE?.format('YYYY-MM-DD') + ' ' + values.INSURED_TIME?.format('HH:mm:ss')))) return { DISABLED: true, ...f };
            if (index === 1 && (moment(f.arrivalTime) > moment(values.END_DATE?.format('YYYY-MM-DD') + ' ' + values.INSURED_TIME?.format('HH:mm:ss')) || moment(f.arrivalTime) < moment(values.START_DATE?.format('YYYY-MM-DD') + ' ' + values.INSURED_TIME?.format('HH:mm:ss')))) return { DISABLED: true, ...f };
            return ({ CHECKED: true, ...f });
          }));
        }
        if (flights.length !== 1) {
          setFieldValue(`FLIGHT_INFOS[${index}].SEARCH_RESULT`, [...flights].map((f: Flight, i: number) => {
            if (index === 0 && (moment(f.departureTime) < moment(values.START_DATE?.format('YYYY-MM-DD') + ' ' + values.INSURED_TIME?.format('HH:mm:ss')) || moment(f.departureTime) > moment(values.END_DATE?.format('YYYY-MM-DD') + ' ' + values.INSURED_TIME?.format('HH:mm:ss')))) return { DISABLED: true, ...f };
            if (index === 1 && (moment(f.arrivalTime) > moment(values.END_DATE?.format('YYYY-MM-DD') + ' ' + values.INSURED_TIME?.format('HH:mm:ss')) || moment(f.arrivalTime) < moment(values.START_DATE?.format('YYYY-MM-DD') + ' ' + values.INSURED_TIME?.format('HH:mm:ss')))) return { DISABLED: true, ...f };
            return { ...f };
          }));
        }
      }
      if (res.returnCode !== ReturnCode.CodeSuccess) {
        sweetAlertService.modal({
          icon: SweetAlertIcon.Info,
          title: '查詢錯誤',
          html: res.returnDesc
        });
      }
    }
  }

  // #endregion

  /**
   * @description 依是否受監護宣告決定是否清空設定
  */
  handleResetFormVal = (e: React.MouseEvent<HTMLInputElement>) => {
    if (e.currentTarget.value === YesNo.Yes) {
      const travelWarnings = [...this.state.travelWarnings];
      const tempCalc = { ...this.props.tempCalc };
      const transportSysOpts = [...this.state.transportSysOpts];
      const yesNoSysOpts = [...this.state.yesnoSysOpts];
      // 改為不清除表單
      // this.handleResetVal();
      this.setState({
        ...initState,
        ...tempCalc, // 載入原試算頁資料 (2024/07/15)
        termStatus: commonService.getInitTermStatus(this.props.docLinks),
        editedTempCalc: tempCalc,
        isDeclared: e.currentTarget.value === YesNo.Yes,
        travelWarnings: travelWarnings,
        transportSysOpts: transportSysOpts,
        yesnoSysOpts: yesNoSysOpts
      });
      this.formikRef.current.setFieldValue('DECLARED', YesNo.Yes);
    } else {
      if (this.props.tempCalc && this.props.tempCalc.tempCalcFormVal) {
        const prodId = this.props.tempCalc.tempCalcFormVal.PROD_ID;
        const showQuickClaim = prodId === TravelPlanType.Abroad || prodId === TravelPlanType.NTAG;

        this.handleRestoreVal();
        this.setState(prev => ({ ...prev, showQuickClaim: showQuickClaim, isDeclared: false }));
      } else {
        this.handleRestoreVal();
        this.setState(prev => ({ ...prev, showQuickClaim: true, isDeclared: false }));
      }
    }
    if (this.formikRef.current.values.PROVIDE_INFO === YesNo.Yes) this.setState(prev => ({ ...prev, showAirPlaneInfo: true }));
  }

  /**
   * @description 切換同意/不同意航班資訊重置航班資訊表單
   */
  handleResetVal = () => {
    const setFieldValue = this.formikRef.current.setFieldValue;
    setFieldValue('TOURIST_DESTINATION', '');
    setFieldValue('TOURIST_COUNTRY', '');
    setFieldValue('TRANSPORT', '');
    if (this.props.tempCalc.tempCalcFormVal) {
      setFieldValue('FLIGHT_INFOS', [
        { FDATE: this.props.tempCalc.tempCalcFormVal.START_DATE, CARRIER_ID: '', FLIGHT_NO: '', SEARCH_RESULT: [] },
        { FDATE: this.props.tempCalc.tempCalcFormVal.END_DATE, CARRIER_ID: '', FLIGHT_NO: '', SEARCH_RESULT: [] }
      ]);
    } else {
      setFieldValue('FLIGHT_INFOS', [
        { FDATE: new Date().toDateString(), CARRIER_ID: '', FLIGHT_NO: '', SEARCH_RESULT: [] },
        { FDATE: new Date().toDateString(), CARRIER_ID: '', FLIGHT_NO: '', SEARCH_RESULT: [] }
      ]);
    }
    // setFieldValue('CONTRACTS', this.handleGetContracts(this.props.docLinks));
  }

  /**
   * @descroption 更改回不受監護宣告，帶入航班日期
   */
  handleRestoreVal = () => {
    const setFieldValue = this.formikRef.current.setFieldValue;
    const values = this.formikRef.current.values;
    setFieldValue('DECLARED', YesNo.No);
    setFieldValue('FLIGHT_INFOS', [
      { ...values.FLIGHT_INFOS[0], FDATE: this.props.tempCalc.tempCalcFormVal?.START_DATE },
      { ...values.FLIGHT_INFOS[1], FDATE: this.props.tempCalc.tempCalcFormVal?.END_DATE }
    ]);
    // setFieldValue('CONTRACTS', this.handleGetContracts(this.props.docLinks));
  }

  // #region 投保日期相關方法

  /**
   * @description 判斷投保天數是否更動，重新進行保費試算
   */
  handleInsuredDateChange = async (startDate: any, endDate: any, period: number, values: IFill1stFormValue, setFieldValue: any, setFieldError: any) => {
    console.log('exe')
    if (startDate && endDate) {
      const flightInfos = _.map(values.FLIGHT_INFOS, (flightInfo: FlightInfo) => {
        const isReasonableTime = moment(flightInfo.FDATE).isBetween(moment(startDate).startOf('day'), moment(endDate).endOf('day'));
        const newFlightInfo: FlightInfo = {
          /** 航班日期 */
          FDATE: isReasonableTime ? flightInfo.FDATE : '',
          /** 航班公司代碼 */
          CARRIER_ID: flightInfo.CARRIER_ID,
          /** 航班編號 */
          FLIGHT_NO: flightInfo.FLIGHT_NO,
          /** 查詢結果航班資訊 */
          SEARCH_RESULT: isReasonableTime ? flightInfo.SEARCH_RESULT : new Array(0)
        };
        return newFlightInfo;
      });

      setFieldValue('FLIGHT_INFOS', flightInfos);

      const newPeriod = moment(endDate).diff(startDate, 'd');
      const maxPeriod = this.props.tempCalc.maxPeriod || 0;

      const error = this.handleValidInsuredRange(startDate);
      if (error) {
        // 更新原本試算頁暫存的 form 值
        const newFormVal: ICalcFormValue = {
          ...this.state.editedTempCalc.tempCalcFormVal as ICalcFormValue,
          START_DATE: moment(startDate).format('YYYY/MM/DD'),
          END_DATE: moment(endDate).format('YYYY/MM/DD'),
          INSURE_PERIOD: newPeriod
        };

        this.setState({
          editedTempCalc: {
            ...this.props.tempCalc,
            tempCalcFormVal: newFormVal,
            evalInfo: undefined,
            evalExpanData: undefined
          }
        });

        return;
      }

      if (newPeriod < 1 || newPeriod >= maxPeriod) return;

      const evalReq = {
        ...this.props.tempCalc.evalReq,
        START_DATE: moment(startDate).format('YYYYMMDD'),
        END_DATE: moment(endDate).format('YYYYMMDD'),
        INSURE_PERIOD: newPeriod
      };

      // 更新原本試算頁暫存的 form 值
      const newFormVal: ICalcFormValue = {
        ...this.state.editedTempCalc.tempCalcFormVal as ICalcFormValue,
        START_DATE: moment(startDate).format('YYYY/MM/DD'),
        END_DATE: moment(endDate).format('YYYY/MM/DD'),
        INSURE_PERIOD: newPeriod
      };
      this.setState(prevState => {
        return {
          ...prevState,
          editedTempCalc: {
            ...prevState.editedTempCalc,
            tempCalcFormVal: newFormVal,
            evalReq: evalReq as EvalReq
          }
        };
      });

      // 修改投保日期後的投保天數大於 0 且與原本不同，執行保費試算
      if (newPeriod > 0 && newPeriod !== period && this.props.tempCalc.evalReq) {
        const result: any = await service.evalProd(evalReq as EvalReq);
        if (result && result.EVAL_RESULT) {
          // 取得攤平後的試算資料
          const expandDatas = commonService.expandEvalResult(result);

          // 取得新的方案資料
          const oldPlanData = { ...this.state.editedTempCalc.planData } as EvalExpans;
          const newPladData = _.find(expandDatas, (expan: EvalExpans) =>
            expan.INS_TYPE_ID === oldPlanData.INS_TYPE_ID &&
            expan.PROD_ID === oldPlanData.PROD_ID &&
            expan.HEADER.PLAN_ID === oldPlanData.HEADER.PLAN_ID);

          this.setState({
            editedTempCalc: {
              tempCalcFormVal: newFormVal,
              evalReq: evalReq as EvalReq,
              evalInfo: result,
              evalExpanData: expandDatas,
              planData: newPladData
            }
          });
          this.props.onReCalcFillst(newPladData, startDate, endDate);
          setFieldValue('INSURE_PERIOD', newPeriod);
        } else {
          _.forEach(Object.keys(result), (errorKey: string) => {
            setFieldError(errorKey, result[errorKey]);
          });
        }
      }
    }
  }

  handleValidInsuredRange = (sDate: any) => {
    const { tempCalcFormVal } = this.props.tempCalc;
    if (tempCalcFormVal && sDate) {
      const startDate = moment(sDate).format('YYYYMMDD');
      const validInsuredDate = (tempCalcFormVal.INS_COUNT === InsCount.One && tempCalcFormVal.INSURED_SUBJECT === InsureSubject.Relatives) ||
        (tempCalcFormVal.INS_COUNT === InsCount.MORE && tempCalcFormVal.INSURED_SUBJECT === InsureSubject.All);

      if (validInsuredDate) {
        // 改取系統參數
        if (moment(moment().add(this.state.travelPeriod, 'd').format('YYYYMMDD')).isAfter(moment(startDate))) {
          sweetAlertService.modal({
            icon: SweetAlertIcon.Info,
            html: commonService.getCodeMsg(this.props.UICode, CodeId.U022)
          });

          return true;
        }
      }
    }
    return false;
  }

  /**
   * @description 投保日期時間更動事件
  */
  handleInsuredTimeSelect = (insuredTimeVal: any, setFieldValue: any) => {
    const insuredTime = moment(insuredTimeVal);
    setFieldValue('INSURED_TIME', insuredTime);
    this.setState({
      editedTempCalc: {
        ...this.state.editedTempCalc,
        tempCalcFormVal: {
          ...this.state.editedTempCalc.tempCalcFormVal as ICalcFormValue,
          INSURED_TIME: insuredTime
        }
      },
      showInsuredTime: false
    });
  }

  // #endregion

  /**
   * @description 表單 Submit 事件
   */
  handleFormSubmit = (values: IFill1stFormValue) => {
    // 檢核投保日期是否正確
    const error = this.handleValidInsuredRange(values.START_DATE);
    if (error) return;

    if (this.state.tempTravels.length <= 0) {
      sweetAlertService.modal({
        icon: SweetAlertIcon.Info,
        html: '請選擇旅遊地點'
      });

      return;
    }

    let flightInfoCheck = false;

    _.forEach(values.FLIGHT_INFOS, (flightInfos: FlightInfo) => {
      _.forEach(flightInfos.SEARCH_RESULT, (flightSchedule: any) => {
        if (flightSchedule.CHECKED && !flightInfoCheck) {
          flightInfoCheck = flightSchedule.CHECKED;
        }
      });
    });

    const flightInfoError = values.TRANSPORT === Transport.Airplane &&
      values.PROVIDE_INFO === YesNo.Yes &&
      (values.FLIGHT_INFOS.length === 0 || !flightInfoCheck);

    if (flightInfoError) {
      sweetAlertService.modal({
        icon: SweetAlertIcon.Info,
        html: '請選擇航班資訊'
      });

      return;
    }

    let flightDateError = false;

    values.FLIGHT_INFOS.forEach((flightInfos: FlightInfo, index: number) => {
      flightInfos.SEARCH_RESULT.forEach((flightSchedule: FlightWithStatus) => {
        if (flightSchedule.CHECKED) {
          if (index === 0 && (moment(flightSchedule.departureTime) < moment(values.START_DATE?.format('YYYY-MM-DD') + ' ' + values.INSURED_TIME?.format('HH:mm:ss')) || moment(flightSchedule.departureTime) > moment(values.END_DATE?.format('YYYY-MM-DD') + ' ' + values.INSURED_TIME?.format('HH:mm:ss')))) flightDateError = true;
          if (index === 1 && (moment(flightSchedule.arrivalTime) > moment(values.END_DATE?.format('YYYY-MM-DD') + ' ' + values.INSURED_TIME?.format('HH:mm:ss')) || moment(flightSchedule.arrivalTime) < moment(values.START_DATE?.format('YYYY-MM-DD') + ' ' + values.INSURED_TIME?.format('HH:mm:ss')))) flightDateError = true;
        }
      });
    });

    if (flightDateError) {
      sweetAlertService.modal({
        icon: SweetAlertIcon.Info,
        html: '您勾選的去/回程航班不在本次申請的保險期間內，請確認。'
      });

      return;
    }

    this.props.onSubmit(values, this.state);
  }

  /**
   * @description 從 server 取得時間
   */
  getSysTime = async () => {
    const sysTime = Math.ceil(await apiCommonService.fetchSysTime() / 1000);
    this.setState(prevState => {
      return {
        ...prevState,
        sysTime: sysTime
      };
    });
  }

  render() {
    // console.warn('🚀 ~ InsureProcessFill1st ~ this.props:', this.props);

    const validationSchema = Yup.object().shape({
      START_DATE: Yup.string().required('此為必填欄位').nullable(),
      END_DATE: Yup.string().required('此為必填欄位').nullable(),
      INSURED_TIME: Yup.string().when('DECLARED', (declareVal: any, schema: any) => {
        return declareVal === YesNo.No ? schema.required('此為必填欄位') : schema;
      }).test('reasonable time', '請重新選擇時間', (val: any) => {
        if (this.formikRef && this.formikRef.current && this.formikRef.current.values && val) {
          return commonService.getDisableTime(this.formikRef.current.values.START_DATE, this.state.sysTime).indexOf(+moment(val).format('HH')) === -1;
        }
        return true;
      }).nullable(),
      // TRANSPORT: Yup.string().when('DECLARED', (declareVal: any, schema: any) => {
      //   return declareVal === YesNo.No ? schema.required('此為必填欄位') : schema;
      // }),
      TOURIST_DESTINATION: Yup.string().when('DECLARED', (declareVal: any, schema: any) => {
        return declareVal === YesNo.No && this.state.tempTravels.length === 0 ? schema.required('此為必填欄位') : schema;
      }),
      TOURIST_COUNTRY: Yup.string().when('DECLARED', (declareVal: any, schema: any) => {
        return declareVal === YesNo.No && this.state.tempTravels.length === 0 ? schema.required('此為必填欄位') : schema;
      }),
      DECLARED: Yup.string().required('此為必填欄位'),
      FLIGHT_INFOS: Yup.array().when('PROVIDE_INFO', (val: any, schema: any) => {
        return val === 'Y' ? schema.test('required one', '同意理賠通知服務須至少勾選一個航班資訊，或請改為不同意此服務。', (val: any) => {
          return val && val.some((item: any) => item.SEARCH_RESULT.some((resule: any) => resule.CHECKED === true));
        }) : schema;
      })

    });

    // console.warn("🚀 ~ InsureProcessFill1st ~ render ~ this.state:", this.state)
    const {
      programSummaryVisible,
      programSummaryDetailsOpen,
      insuranceInfoProgramDetailsOpen
    } = this.state;
    const programSummaryClasses = ['program-summary'];
    const programSummaryDetailsElemHeight = programSummaryDetailsOpen ? 'calc(100vh - 335px)' : 0;
    const insuranceInfoProgramDetailsElemHeight = insuranceInfoProgramDetailsOpen ? '100%' : 0;

    if (programSummaryVisible) {
      programSummaryClasses.push('program-summary--active');
    }

    // #region 產生投保資訊區塊

    /**
    * @description 取得保險期間
   */
    const handleGetInsperiod = (sDate: any, eDate: any, insureTime: any) => {
      if (sDate && eDate && insureTime) {
        const startDate = moment(sDate).format('YYYY/MM/DD');
        const endDate = moment(eDate).format('YYYY/MM/DD');
        const time = moment(insureTime).format('HH');
        const period = moment(endDate).diff(moment(startDate), 'd');
        return (
          <>
            <p>{startDate} {time}:00 ~ {endDate} {time}:00</p>
            <p>共投保 {period} 天</p>
          </>
        );
      }
      return '';
    };

    /**
     * @description 等投保日期、時間都選定後顯示訊息
    */
    const handleShowPeriodMsg = (sDate: any, eDate: any, insTime?: moment.Moment) => {
      if (this.formikRef.current) {
        if (!sDate || !eDate || !insTime) return '';
        if (!sDate || !eDate || !insTime) return '';
        const period = moment(eDate).diff(sDate, 'd');
        return (
          <p>共投保 <span style={{ color: '#FE3208' }}>{period}</span> 天，保障期間為 <span style={{ color: '#FE3208' }}>{moment(sDate).format('YYYY/MM/DD')} {moment(insTime).format('HH')}:00 - {moment(eDate).format('YYYY/MM/DD')} {moment(insTime).format('HH')}:00</span></p>
        );
      }
    };

    /**
    * @description 取得旅遊/活動地點
   */
    const handleGetTravelInfo = () => {
      if (!this.state.tempTravels || this.state.tempTravels.length === 0) return '';

      return _.reduce(_.map(this.state.tempTravels, (travels: TravelWarningExpandData) => travels.COUNTRY_NAME as string), (res: string, country: string) => {
        return `${res}、${country}`;
      });
    };

    /**
     * @description 旅遊資訊長度超過5字元格式化為 xxxxx...點選顯示完整資訊
     * @param travelInfoStr 旅遊/活動地點組合後的顯示資訊
     */

    const handleTravelInfoFormat = (travelInfoStr: string) => {
      if (!travelInfoStr) return;

      if (travelInfoStr && travelInfoStr.length <= 5) {
        return travelInfoStr;
      }

      return (
        <>
          {`${travelInfoStr.substring(0, 5)}`}
          <span
            className="element__link"
            onClick={() => {
              sweetAlertService.modal({
                title: '旅遊/活動地點',
                html: travelInfoStr
              });
            }}
          >...
          </span>
        </>
      );
    };

    /**
   * @description 切換 Fold 組件開啟/關閉
   * @param foldIndex 資料中使用 Fold 組件的 Row index
   */
    const handleFoldToggle = (foldIndex: number) => {
      const updatedPcDetailFoldsOpen = [...this.state.detailFoldsOpen];
      updatedPcDetailFoldsOpen[foldIndex] = !updatedPcDetailFoldsOpen[foldIndex];
      this.setState(prevState => {
        return {
          ...prevState,
          detailFoldsOpen: updatedPcDetailFoldsOpen
        };
      });
    };

    let programFooterList: JSX.Element[];
    const planDataContent: JSX.Element[] = [];
    if (this.state.editedTempCalc.planData) {
      if (this.state.editedTempCalc.planData.BODY_O15 && this.props.tempCalc.evalReq?.OVER15_COUNT !== '') {
        planDataContent.push(
          <div className="program-list__item" key="15歲以上投保方案">
            15歲以上投保方案
          </div>
        );
        _.forEach(this.state.editedTempCalc.planData.BODY_O15, (bodyContent: ExpanBodyContent, bodyContentIndex: number) => {
          switch (bodyContent.TYPE) {
            case EvalInfoBodyType.ROW: {
              // 調整顯示文字
              let rowFIELD = bodyContent.FIELD;
              if (this.props.tempInsureds && this.props.tempInsureds.length > 0) {
                const hasOver15InsuredCalc = _.some(this.props.tempInsureds, (insured: InsuredState) => insured.INSURED_CALC && !insured.INSURED_IS_UNDER15);
                const hasUnder15InsuredCalc = _.some(this.props.tempInsureds, (insured: InsuredState) => insured.INSURED_CALC && insured.INSURED_IS_UNDER15);

                if (bodyContent.ROWTITLE.indexOf('意外死亡及失能') !== -1) {
                  rowFIELD = hasOver15InsuredCalc ? commonService.getCodeMsg(this.props.UICode, CodeId.U020) : '';
                }

                if (bodyContent.ROWTITLE.indexOf('意外失能(15歲以下)') !== -1) {
                  rowFIELD = hasUnder15InsuredCalc ? commonService.getCodeMsg(this.props.UICode, CodeId.U020) : '';
                }
              }

              planDataContent.push(
                <div className="program-details__table-tr" key={`${bodyContentIndex}-O15`}>
                  <div className="program-details__table-td">{bodyContent.ROWTITLE}</div>
                  <div className="program-details__table-td">{rowFIELD}</div>
                </div>
              );

              break;
            }
            case EvalInfoBodyType.FOLDABLE: {
              planDataContent.push(
                <div className="program-details__table-tr" key={`${bodyContentIndex}-O15`}>
                  <div className="program-details__table-td">{bodyContent.ROWTITLE}</div>
                  <div className="program-details__table-td">
                    {
                      bodyContent.BODY && bodyContent.BODY?.length > 0 && (
                        <button
                          type="button"
                          className={'element__icon-button' + ((this.state.detailFoldsOpen[bodyContentIndex] ? ' element__icon-button--close' : ' element__icon-button--add'))}
                          onClick={() => handleFoldToggle(bodyContentIndex)}
                        >
                          {this.state.detailFoldsOpen[bodyContentIndex] ? '關閉詳細資訊' : '開啟詳細資訊'}
                        </button>
                      )
                    }
                  </div>
                </div>
              );
              const bodyChild = (
                <div className="program-details__table-tr" key={`child${bodyContentIndex}-O15`}>
                  <ul className="program-details__items">
                    {
                      _.map(bodyContent.BODY, (bodyBaseContent: ExpanBodyBaseContent, bodyBaseContentIndex: number) => {
                        return (
                          <li key={bodyBaseContentIndex}>
                            <span>{bodyBaseContent.ROWTITLE}</span>
                            <span>{bodyBaseContent.FIELD}</span>
                          </li>
                        );
                      })
                    }
                  </ul>
                </div>
              );
              planDataContent.push(
                <div className="premium-calc-list__body-foldable-content">
                  <Fold isOpen={this.state.detailFoldsOpen[bodyContentIndex] as boolean}>
                    {bodyChild}
                  </Fold>
                </div>
              );
              break;
            }
          }
        });
      }
      if (this.state.editedTempCalc.planData.SUBTOTAL_O15[0] && this.props.tempCalc.evalReq?.OVER15_COUNT !== '') {
        planDataContent.push(
          <div className="program-details__table-tr" key="subTotalO15">
            <div className="program-details__table-td">{this.state.editedTempCalc.planData.SUBTOTAL_O15[0].ROWTITLE}</div>
            <div className="program-details__table-td" style={{ color: '#FE3208' }}>{this.state.editedTempCalc.planData.SUBTOTAL_O15[0].FIELD}</div>
          </div>
        );
      }
      if (this.state.editedTempCalc.planData.BODY_U15 && this.props.tempCalc.evalReq?.UNDER15_COUNT !== '') {
        planDataContent.push(
          <div className="program-list__item" key="未滿15歲投保方案">
            未滿15歲投保方案
          </div>
        );
        _.forEach(this.state.editedTempCalc.planData.BODY_U15, (bodyContent: ExpanBodyContent, bodyContentIndex: number) => {
          switch (bodyContent.TYPE) {
            case EvalInfoBodyType.ROW: {
              // 調整顯示文字
              let rowFIELD = bodyContent.FIELD;
              if (this.props.tempInsureds && this.props.tempInsureds.length > 0) {
                const hasOver15InsuredCalc = _.some(this.props.tempInsureds, (insured: InsuredState) => insured.INSURED_CALC && !insured.INSURED_IS_UNDER15);
                const hasUnder15InsuredCalc = _.some(this.props.tempInsureds, (insured: InsuredState) => insured.INSURED_CALC && insured.INSURED_IS_UNDER15);

                if (bodyContent.ROWTITLE.indexOf('意外死亡及失能') !== -1) {
                  rowFIELD = hasOver15InsuredCalc ? commonService.getCodeMsg(this.props.UICode, CodeId.U020) : '';
                }

                if (bodyContent.ROWTITLE.indexOf('意外失能(15歲以下)') !== -1) {
                  rowFIELD = hasUnder15InsuredCalc ? commonService.getCodeMsg(this.props.UICode, CodeId.U020) : '';
                }
              }

              planDataContent.push(
                <div className="program-details__table-tr" key={`${bodyContentIndex}-U15`}>
                  <div className="program-details__table-td">{bodyContent.ROWTITLE}</div>
                  <div className="program-details__table-td">{rowFIELD}</div>
                </div>
              );

              break;
            }
            case EvalInfoBodyType.FOLDABLE: {
              planDataContent.push(
                <div className="program-details__table-tr" key={`${bodyContentIndex}-U15`}>
                  <div className="program-details__table-td">{bodyContent.ROWTITLE}</div>
                  <div className="program-details__table-td">
                    {
                      bodyContent.BODY && bodyContent.BODY?.length > 0 && (
                        <button
                          type="button"
                          className={'element__icon-button' + ((this.state.detailFoldsOpen[bodyContentIndex] ? ' element__icon-button--close' : ' element__icon-button--add'))}
                          onClick={() => handleFoldToggle(bodyContentIndex)}
                        >
                          關閉詳細資訊
                        </button>
                      )
                    }
                  </div>
                </div>
              );
              const bodyChild = (
                <div className="program-details__table-tr" key={`child${bodyContentIndex}-U15`}>
                  <ul className="program-details__items">
                    {
                      _.map(bodyContent.BODY, (bodyBaseContent: ExpanBodyBaseContent, bodyBaseContentIndex: number) => {
                        return (
                          <li key={bodyBaseContentIndex}>
                            <span>{bodyBaseContent.ROWTITLE}</span>
                            <span>{bodyBaseContent.FIELD}</span>
                          </li>
                        );
                      })
                    }
                  </ul>
                </div>
              );
              planDataContent.push(
                <div className="premium-calc-list__body-foldable-content">
                  <Fold isOpen={this.state.detailFoldsOpen[bodyContentIndex] as boolean}>
                    {bodyChild}
                  </Fold>
                </div>
              );
              break;
            }
          }
        });
      }
      if (this.state.editedTempCalc.planData.SUBTOTAL_U15 && this.props.tempCalc.evalReq?.UNDER15_COUNT !== '') {
        planDataContent.push(
          <div className="program-details__table-tr" key="subTotalU15">
            <div className="program-details__table-td">{this.state.editedTempCalc.planData.SUBTOTAL_U15[0].ROWTITLE}</div>
            <div className="program-details__table-td" style={{ color: '#FE3208' }}>{this.state.editedTempCalc.planData.SUBTOTAL_U15[0].FIELD}</div>
          </div>
        );
      }
      programFooterList = _.map(this.state.editedTempCalc.planData.FOOTER, (footerContent: ExpanFooterContent, footerIndex: number) => {
        const total = commonService.thousandFormat(footerContent.TOTAL.replace(/.*\s([\d]{0,})\s元/, '$1'));
        planDataContent.push(
          <div className="program-details__table-tr" key={`footer${footerIndex}`}>
            <div className="program-details__table-td">{footerContent.TITLE}</div>
            <div className="program-details__table-td" style={{ color: '#FE3208' }}>{footerContent.TOTAL.replace(/(.*\s)([\d]{0,})(\s元)/, `$1${total}$3`)}</div>
          </div>
        );
        // console.warn('🚀 ~ InsureProcessFill1st ~ this.props.tempFill1st.tempFill1stFormVal:', this.props.tempFill1st.tempFill1stFormVal);
        return (
          <div className="program-list__item" key={`programFooter${footerIndex}`}>
            <span>保費合計</span>
            {
              (!this.props.tempState.tempFill2nd.tempFill2ndFormVal ||
                this.props.tempState.tempFill2nd.tempFill2ndFormVal.INSUREDS.length === 0 ||
                (this.props.tempState.tempFill2nd.tempFill2ndFormVal.INSUREDS.length === 1 &&
                  this.props.tempState.tempFill2nd.tempFill2ndFormVal.INSUREDS[0].INSURED_CALC === '') ||
                (this.props.tempState.tempFill2nd.tempFill2ndFormVal.INSUREDS.length === 1 &&
                  this.props.tempState.tempFill1st.tempFill1stState.editedTempCalc.planData?.FOOTER[0].TOTAL ===
                  this.props.tempState.tempFill2nd.tempFill2ndState.planData?.FOOTER[0].TOTAL))
                ? <p>{this.props.tempCalc.planData?.FOOTER[0].TOTAL}</p>
                : (this.props.tempState.tempCalc.planData?.FOOTER[0].TOTAL !==
                  this.props.tempState.tempFill1st.tempFill1stState.editedTempCalc.planData?.FOOTER[0].TOTAL &&
                  this.props.tempState.tempCalc.planData?.FOOTER[0].TOTAL !==
                  this.props.tempState.tempFill2nd.tempFill2ndState.planData?.FOOTER[0].TOTAL)
                  ? <p>{this.props.tempCalc.planData?.FOOTER[0].TOTAL}</p>
                  : <p>{this.props.tempState.tempFill1st.tempFill1stState.editedTempCalc.planData?.FOOTER[0].TOTAL}</p>
            }
          </div>
        );
      });
    }

    // #endregion

    // #region 產生是否受監護宣告區塊

    let declareArea: JSX.Element[];
    if (this.state.yesnoSysOpts && this.state.yesnoSysOpts.length > 0) {
      declareArea = _.map(this.state.yesnoSysOpts, (sysOpt: SysOption, index: number) => {
        return (
          <div className="element__radio-group" key={index}>
            <label htmlFor={`undeclared-radio-${sysOpt.PARAM_VALUE}`}>
              <div className="element__radio">
                <Field
                  type="radio"
                  name="DECLARED"
                  id={`undeclared-radio-${sysOpt.PARAM_VALUE}`}
                  value={sysOpt.PARAM_VALUE}
                  onClick={(e: React.MouseEvent<HTMLInputElement>) => this.handleResetFormVal(e)}
                />
                <div className="element__radio-btn" />
              </div>
              <span>{sysOpt.PARAM_TEXT}</span>
            </label>
          </div>
        );
      });
    }

    // #endregion

    // #region 產生 旅遊/活動地點 下拉選單值、熱門國家

    let touristArea: any;
    let touristCountry: any;
    let hotCountryTags: JSX.Element;
    const prodId = this.props.tempCalc?.planData?.PROD_ID;
    let isDomestic = prodId === TravelPlanType.Domestic || prodId === TravelPlanType.MPA || prodId === TravelPlanType.SPI || prodId === TravelPlanType.WPA;
    let isBroad = prodId === TravelPlanType.Abroad || prodId === TravelPlanType.NTAG;

    if (this.props.travelWarnings && this.props.travelWarnings.length > 0) {
      if (this.state.tempTravels && this.state.tempTravels.length > 0 && this.state.tempTravels[0].GEOAREA_ID) {
        isDomestic = this.state.tempTravels[0].GEOAREA_ID === GeoAreaId.Domestic;

        isBroad = this.state.tempTravels[0].GEOAREA_ID !== GeoAreaId.Domestic;
      }

      let travelWarnings = [...this.props.travelWarnings];
      // 為國內保險
      if (isDomestic) {
        travelWarnings = _.filter(travelWarnings,
          (travelWarning: TravelWarning) => travelWarning.GEOAREA_ID === GeoAreaId.Domestic);
      }

      // 為國外保險
      if (isBroad) {
        travelWarnings = _.filter(travelWarnings,
          (travelWarning: TravelWarning) => travelWarning.GEOAREA_ID !== GeoAreaId.Domestic);
        // 判斷是否為申根保險
        if (prodId === TravelPlanType.NTAG) {
          travelWarnings = _.filter(travelWarnings, (travelWarning: TravelWarning) => travelWarning.GEOAREA_ID === GeoAreaId.EU);
        }
      }

      touristArea = _.map(travelWarnings, (travelWarning: TravelWarning, index: number) => {
        return <option key={index} value={travelWarning.GEOAREA_ID}>{travelWarning.GEOAREA_NAME}</option>;
      });

      if (this.state.activeTouristArea) {
        const area = _.find(this.props.travelWarnings, (travelWarning: TravelWarning, index: number) => travelWarning.GEOAREA_ID === this.state.activeTouristArea);
        if (!area) return;

        touristCountry = _.map(area.COUNTRYS, (countrys: TravelCountryContent, index: number) => {
          // 若為申根國家，僅顯示申根註記為 1 的國家
          if (prodId === TravelPlanType.NTAG) {
            if (countrys.SCHENGEN === TravelSchengen.No) return;

            return <option key={index} value={countrys.COUNTRY_ID}>{countrys.COUNTRY_NAME}</option>;
          } else {
            return <option key={index} value={countrys.COUNTRY_ID}>{countrys.COUNTRY_NAME}</option>;
          }
        });
      }

      // 建立熱門國家選項
      if (this.state.travelWarnings.length > 0) {
        let hotCountrys: any;
        hotCountrys = _.filter(this.state.travelWarnings, (travel: TravelWarningExpandData) => travel.HOT_COUNTRY).sort((first: any, second: any) => first.HOT_COUNTRY - second.HOT_COUNTRY);
        // 已選取旅遊地點，且為國內，篩選熱門國家選項為國內的
        if (isDomestic) {
          hotCountrys = _.filter(this.state.travelWarnings, (travel: TravelWarningExpandData) => travel.HOT_COUNTRY && travel.GEOAREA_ID === GeoAreaId.Domestic)
            .sort((first: any, second: any) => first.HOT_COUNTRY - second.HOT_COUNTRY);
        }

        // 已選取旅遊地點，且為國外，篩選熱門國家選項不為國內的
        if (isBroad) {
          hotCountrys = _.filter(this.state.travelWarnings, (travel: TravelWarningExpandData) => travel.HOT_COUNTRY && travel.GEOAREA_ID !== GeoAreaId.Domestic)
            .sort((first: any, second: any) => first.HOT_COUNTRY - second.HOT_COUNTRY);
          // 為申根保險，僅顯示申根國家
          if (prodId === TravelPlanType.NTAG) {
            hotCountrys = _.filter(hotCountrys, (country: TravelWarningExpandData) => country.SCHENGEN === TravelSchengen.Yes);
          }
        }

        if (hotCountrys.length > 0 && !isTravelBubble) {
          const child = _.map(hotCountrys, (hotCountry: TravelWarningExpandData, index: number) => {
            return (
              <Link
                to="/"
                key={index}
                className="element__link"
                onClick={(e: React.MouseEvent<HTMLAnchorElement>) => {
                  e.preventDefault();
                  if (!this.state.isDeclared) {
                    this.handleSetTravelTag(hotCountry.COUNTRY_ID || '');
                    this.setState({ activeTouristArea: '' });
                    this.formikRef.current.setFieldValue('TOURIST_DESTINATION', '');
                    this.formikRef.current.setFieldValue('TOURIST_COUNTRY', '');
                  }
                }}
              >
                {hotCountry.COUNTRY_NAME}
              </Link>
            );
          });
          hotCountryTags = (
            <div className="insurance-info__countrys">
              <span>熱門國家:</span>
              {child}
            </div>
          );
        }
      }
    }

    // #endregion

    // #region 建立 旅遊 tag 用

    let travelTags: JSX.Element[];
    if (this.state.tempTravels.length > 0) {
      travelTags = _.map(this.state.tempTravels, (travel: TravelWarningExpandData, index: number) => {
        return (
          <div className="element__tag" key={index}>
            <button type="button" className="element__tag-btn" onClick={() => this.handleRemoveTravelTag(travel.GEOAREA_ID as string, travel.COUNTRY_ID as string)} />
            <span>{travel.COUNTRY_NAME}</span>
          </div>
        );
      });
    };

    return (
      <div className="insure-process-fill">
        <Formik
          innerRef={this.formikRef}
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={this.handleFormSubmit}
          enableReinitialize
        >
          {
            ({ values, touched, errors, setFieldValue, setFieldTouched, setFieldError, handleChange }) => (
              <Form>
                <div className="insure-process-fill__content">
                  <div className="insurance-info">
                    <div className="insurance-info__title">投保資訊</div>
                    <div className="insurance-info__content">
                      <div className="program-info">
                        <div className="program-info__container">
                          <div className="program-info__header">
                            <span>方案</span>
                            <div className="program-info__header-row">
                              <div className="program-info__block">
                                <span>{this.state.editedTempCalc.planData?.HEADER.TITLE}</span>
                                <button
                                  type="button"
                                  className={'element__icon-button' + (insuranceInfoProgramDetailsOpen ? ' element__icon-button--close' : ' element__icon-button--add')}
                                  onClick={() => this.handleInsuranceInfoProgramDetailsToggle()}
                                  style={{ display: 'none' }}
                                >
                                  {insuranceInfoProgramDetailsOpen ? '關閉詳細資訊' : '開啟詳細資訊'}
                                </button>
                              </div>
                              <span className="element__link" onClick={() => this.props.onEditPlan(this.formikRef.current.values, this.state)}>我要修改方案</span>
                            </div>
                          </div>
                          <div className="program-info__details" style={{ height: insuranceInfoProgramDetailsElemHeight }}>
                            <div className="program-details" ref={this.insuranceInfoProgramDetailsRef}>
                              <div className="program-details__table">
                                {planDataContent}
                              </div>
                            </div>
                          </div>
                          <div className="program-list">
                            <div className="program-list__item">
                              <span>保險期間</span>
                              {handleGetInsperiod(values.START_DATE, values.END_DATE, values.INSURED_TIME)}
                            </div>
                            <div className="program-list__item">
                              <span>旅遊/活動地點</span>
                              <p>{handleTravelInfoFormat(handleGetTravelInfo() as string)}</p>
                            </div>
                            <div className="program-list__item">
                              <span>15歲以上試算總保費</span>
                              <span>({this.props.tempCalc.evalReq?.OVER15_COUNT ? this.props.tempCalc.evalReq.OVER15_COUNT : 0} 位)</span>
                              <p>{this.state.editedTempCalc.planData?.SUBTOTAL_O15[0].FIELD}</p>
                            </div>
                            {this.state.editedTempCalc.planData?.PROD_ID !== TravelPlanType.NTAG &&
                              <div className="program-list__item">
                                <span>15歲以下試算總保費</span>
                                <span>({this.props.tempCalc.evalReq?.UNDER15_COUNT ? this.props.tempCalc.evalReq.UNDER15_COUNT : 0} 位)</span>
                                <p>{this.state.editedTempCalc.planData?.SUBTOTAL_U15[0].FIELD}</p>
                              </div>}
                            {programFooterList}
                          </div>
                        </div>
                      </div>
                      <div className={programSummaryClasses.join(' ')}>
                        <div className="template-content">
                          <div className="program-summary__details" style={{ height: programSummaryDetailsElemHeight }}>
                            <div className="program-summary__details-wrap">
                              <div className="program-details">
                                <div className="program-details__table">
                                  {planDataContent}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="program-list">
                            <div className="program-list__item">
                              <span>保險期間</span>
                              {handleGetInsperiod(values.START_DATE, values.END_DATE, values.INSURED_TIME)}
                            </div>
                            <div className="program-list__item">
                              <span>旅遊/活動地點</span>
                              <p>{handleTravelInfoFormat(handleGetTravelInfo() as string)}</p>
                            </div>
                            <div className="program-list__item">
                              <span>15歲以上試算總保費</span>
                              <span>({this.props.tempCalc.evalReq?.OVER15_COUNT} 位)</span>
                              <p>{this.state.editedTempCalc.planData?.SUBTOTAL_O15[0].FIELD}</p>
                            </div>
                            {this.state.editedTempCalc.planData?.PROD_ID !== TravelPlanType.NTAG &&
                              <div className="program-list__item">
                                <span>15歲以下試算總保費</span>
                                <span>({this.props.tempCalc.evalReq?.UNDER15_COUNT} 位)</span>
                                <p>{this.state.editedTempCalc.planData?.SUBTOTAL_U15[0].FIELD}</p>
                              </div>}
                            {programFooterList}
                          </div>
                        </div>
                      </div>
                      <div className="insurance-info__form" ref={this.insuranceInfoFormRef}>
                        <div className="insurance-info__row">
                          <div className={'element__form-group' + (errors.DECLARED && touched.DECLARED ? ' element__form-group--invalid' : '')}>
                            <div className="element__form-group-title">
                              要/被保險人是否受監護宣告?
                              <span className="element__link" onClick={() => this.props.setGuardianshipStatementModalVisible(true)}>(什麼是監護宣告?)</span>
                            </div>
                            <div className="element__form-group-content" tabIndex={1} data-fieldname="DECLARED">
                              {declareArea}
                            </div>
                            <div className="element__error-message">
                              <ErrorMessage name="DECLARED" />
                              {this.state.isDeclared
                                ? commonService.getCodeMsg(this.props.UICode, CodeId.W001)
                                : ''}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {
                    this.state.showQuickClaim ? (
                      <div className="claims-service">
                        <div className="claims-service__title">
                          <span>理賠通知服務</span>
                        </div>
                        <p>{commonService.getCodeMsg(this.props.UICode, CodeId.U018)}</p>
                        <div className="claims-service__content">
                          <div className="claims-service__notes">
                            <div className="claims-service__notes-title">
                              <p>{commonService.getCodeMsg(this.props.quickClaimCode, CodeId.HEAD)}</p>
                            </div>
                            <div className="claims-service__notes-content" style={{ height: this.state.claimsServiceNotesElemHeight }}>
                              <ol ref={this.claimsServiceNotesRef}>
                                <li>
                                  <p>{commonService.getCodeMsg(this.props.quickClaimCode, CodeId.QC01)}</p>
                                </li>
                                <li>
                                  <p>{commonService.getCodeMsg(this.props.quickClaimCode, CodeId.QC02)}</p>
                                </li>
                                <li>
                                  <p>{commonService.getCodeMsg(this.props.quickClaimCode, CodeId.QC03)}</p>
                                </li>
                                <li>
                                  <p>{commonService.getCodeMsg(this.props.quickClaimCode, CodeId.QC04)}</p>
                                </li>
                                <li>
                                  <p>{commonService.getCodeMsg(this.props.quickClaimCode, CodeId.QC05)}</p>
                                </li>
                                <li>
                                  <p>{commonService.getCodeMsg(this.props.quickClaimCode, CodeId.QC06)}</p>
                                </li>
                              </ol>
                            </div>
                            <div className="element__form-group">
                              <div className="element__form-group-content">
                                <div className="element__radio-group">
                                  <label htmlFor="PROVIDE_INFO-Y">
                                    <div className="element__radio">
                                      <Field
                                        type="radio" name="PROVIDE_INFO" id="PROVIDE_INFO-Y" value={YesNo.Yes} onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                          if (this.formikRef && this.formikRef.current) {
                                            this.formikRef.current.handleChange(e);
                                          }
                                          this.handleToggleShowAirPlaneInfo(true, setFieldValue);
                                        }}
                                      />
                                      <div className="element__radio-btn" />
                                    </div>
                                    <span>同意注意事項，並填寫航班資訊</span>
                                  </label>
                                </div>
                                <span
                                  className="element__link" onClick={() =>
                                    sweetAlertService.modal({
                                      title: '航班資訊填寫範例',
                                      html: ` ${commonService.getCodeMsg(this.props.UICode, CodeId.W002)}。範例如圖。
                                              <img src=${window.innerWidth > 768 ? require('assets/images/flight-info-example.png') : require('assets/images/flight-info-example-mobile.png')} alt="flight-info-example" />
                                            `,
                                      width: '1000px'
                                    })}
                                >(航班資訊填寫範例)
                                </span>
                                <div className="element__radio-group">
                                  <label htmlFor="PROVIDE_INFO-N">
                                    <div className="element__radio">
                                      <Field
                                        type="radio" name="PROVIDE_INFO" id="PROVIDE_INFO-N" value={YesNo.No} onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                          if (this.formikRef && this.formikRef.current) {
                                            this.formikRef.current.handleChange(e);
                                          }
                                          this.handleToggleShowAirPlaneInfo(false, setFieldValue);
                                          this.handleResetVal();
                                        }}
                                      />
                                      <div className="element__radio-btn" />
                                    </div>
                                    <span>不同意，無法提供航班資訊</span>
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                          {
                            this.state.showAirPlaneInfo ? (
                              <div className="claims-service__flight" data-fieldname="FLIGHT_INFOS">
                                <FieldArray name="FLIGHT_INFOS">
                                  {
                                    () => (
                                      <>
                                        {
                                          values.FLIGHT_INFOS ? (
                                            _.map(values.FLIGHT_INFOS, (flightInfo: FlightInfo, index: number) => {
                                              return (
                                                <div className="claims-service__flight-item" key={index}>
                                                  <div className="claims-service__flight-item-row">
                                                    <span>{index === 0 ? '去程航班' : '回程航班'}</span>
                                                  </div>
                                                  <div className="claims-service__flight-item-row">
                                                    <div className="claims-service__flight-item-col">
                                                      <div className={'element__form-group' + (getIn(errors, `FLIGHT_INFOS[${index}].FDATE`) ? ' element__form-group--invalid' : '')}>
                                                        <div className="element__form-group-title">日期</div>
                                                        <DatePicker
                                                          className="element__input"
                                                          name={`FLIGHT_INFOS[${index}].FDATE`}
                                                          format="YYYY/MM/DD"
                                                          showToday={false}
                                                          onFocus={async () => await this.getSysTime()}
                                                          disabledDate={(current: any) => {
                                                            // if (!values.INSURED_RANGE) return current < moment.unix(this.state.sysTime).add(-1, 'd');
                                                            // const startDate = moment(values.INSURED_RANGE[0]).startOf('day');
                                                            // const endDate = moment(values.INSURED_RANGE[1]).endOf('day');
                                                            if (!values.START_DATE || !values.END_DATE) return current < moment.unix(this.state.sysTime).add(-1, 'd');
                                                            const startDate = values.START_DATE.startOf('day');
                                                            const endDate = values.END_DATE.endOf('day');
                                                            return (!startDate.isSameOrBefore(current) || !endDate.isSameOrAfter(current));
                                                          }}
                                                          onChange={(e) => {
                                                            setFieldValue(`FLIGHT_INFOS[${index}].FDATE`, e?.format('YYYY-MM-DD'));
                                                            setFieldValue(`FLIGHT_INFOS[${index}].SEARCH_RESULT`, new Array(0));
                                                          }}
                                                        />
                                                        <div className="element__error-message">
                                                          {
                                                            getIn(errors, `FLIGHT_INFOS[${index}].FDATE`)
                                                          }
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div className="claims-service__flight-item-col">
                                                      <div className={'element__form-group' + (getIn(errors, `FLIGHT_INFOS[${index}].CARRIER_ID`) ? ' element__form-group--invalid' : '')}>
                                                        <div className="element__form-group-title">航班代碼<span>(英文)</span></div>
                                                        <Field
                                                          component={InputWithRegex}
                                                          regex={NumAndEnglishRegex}
                                                          autoComplete="off"
                                                          name={`FLIGHT_INFOS[${index}].CARRIER_ID`}
                                                          maxLength={5}
                                                          placeholder="請填寫航班代碼"
                                                          className="element__input"
                                                          onBlur={() => {
                                                            setFieldTouched(`FLIGHT_INFOS[${index}].CARRIER_ID`, true);
                                                          }}
                                                          onChange={(val: any) => {
                                                            handleChange(val);
                                                            setFieldValue(`FLIGHT_INFOS[${index}].SEARCH_RESULT`, new Array(0));
                                                          }}
                                                        />
                                                        <div className="element__error-message">
                                                          {
                                                            getIn(errors, `FLIGHT_INFOS[${index}].CARRIER_ID`)
                                                          }
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div className="claims-service__flight-item-col">
                                                      <div className={'element__form-group' + (getIn(errors, `FLIGHT_INFOS[${index}].FLIGHT_NO`) ? ' element__form-group--invalid' : '')}>
                                                        <div className="element__form-group-title">航班號碼<span>(數字)</span></div>
                                                        <Field
                                                          component={InputWithRegex}
                                                          regex={NumAndEnglishRegex}
                                                          autoComplete="off"
                                                          name={`FLIGHT_INFOS[${index}].FLIGHT_NO`}
                                                          maxLength={5}
                                                          placeholder="請填寫航班編號"
                                                          className="element__input"
                                                          onBlur={() => {
                                                            setFieldTouched(`FLIGHT_INFOS[${index}].FLIGHT_NO`, true);
                                                          }}
                                                          onChange={(val: any) => {
                                                            handleChange(val);
                                                            setFieldValue(`FLIGHT_INFOS[${index}].SEARCH_RESULT`, new Array(0));
                                                          }}
                                                        />
                                                        <div className="element__error-message">
                                                          {
                                                            getIn(errors, `FLIGHT_INFOS[${index}].FLIGHT_NO`)
                                                          }
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div className="claims-service__flight-item-col">
                                                      <button
                                                        type="button"
                                                        className="claims-service__flight-inquire-btn"
                                                        onClick={() => this.handleSearchFlightInfo(index, values, setFieldValue, setFieldError, setFieldTouched)}
                                                        disabled={!values.FLIGHT_INFOS[index].FDATE || !values.FLIGHT_INFOS[index].CARRIER_ID || !values.FLIGHT_INFOS[index].FLIGHT_NO}
                                                      >
                                                        查詢
                                                      </button>
                                                    </div>
                                                    {
                                                      values.FLIGHT_INFOS[index].SEARCH_RESULT.length > 0 ? (
                                                        <FieldArray name={`FLIGHT_INFOS[${index}].SEARCH_RESULT`}>
                                                          {
                                                            () => (
                                                              <div className="claims-service__flight-item-col">
                                                                <div className="element__form-group">
                                                                  <div className="element__form-group-title">航班時間及時段(請勾選)</div>
                                                                  <div className="element__checkbox-group">
                                                                    {
                                                                      _.map(values.FLIGHT_INFOS[index].SEARCH_RESULT, (flightSchedule: FlightWithStatus, resultIndex: number) => {
                                                                        return (
                                                                          <label htmlFor={`app-auth-checkbox${index}${resultIndex}`} key={resultIndex}>
                                                                            <div className="element__checkbox">
                                                                              <Field
                                                                                type="checkbox"
                                                                                name={`FLIGHT_INFOS[${index}].SEARCH_RESULT[${resultIndex}].CHECKED`}
                                                                                id={`app-auth-checkbox${index}${resultIndex}`}
                                                                                disabled={flightSchedule.DISABLED}
                                                                              />
                                                                              <div className="element__checkbox-btn" />
                                                                            </div>
                                                                            <div className="claims-service__flight-period">
                                                                              <div className="claims-service__flight-period-item">
                                                                                <span>{flightSchedule.departureAirport}</span>
                                                                                <span>{moment(flightSchedule.departureTime).format('MM/DD HH:mm')}</span>
                                                                              </div>
                                                                              <div className={getIn(values, `FLIGHT_INFOS[${index}].SEARCH_RESULT[${resultIndex}].CHECKED`) ? 'claims-service__flight-period-icon' : 'claims-service__flight-period-icon claims-service__flight-period-icon--disabled'} />
                                                                              <div className="claims-service__flight-period-item">
                                                                                <span>{flightSchedule.arrivalAirport}</span>
                                                                                <span>{moment(flightSchedule.arrivalTime).format('MM/DD HH:mm')}</span>
                                                                              </div>
                                                                            </div>
                                                                          </label>
                                                                        );
                                                                      })
                                                                    }
                                                                  </div>
                                                                  <div className="element__form-group-title element__large-text">去程/回程航班時間須在保期內，以免影響理賠申請。</div>
                                                                </div>
                                                              </div>
                                                            )
                                                          }
                                                        </FieldArray>
                                                      ) : null
                                                    }
                                                  </div>
                                                </div>
                                              );
                                            })
                                          ) : null
                                        }
                                      </>
                                    )
                                  }
                                </FieldArray>
                                {touched.FLIGHT_INFOS && errors.FLIGHT_INFOS && (values.FLIGHT_INFOS[0].SEARCH_RESULT.length > 0 || values.FLIGHT_INFOS[1].SEARCH_RESULT.length > 0) &&
                                  <div className="element__error-message element__large-text">
                                    <ExclamationCircleOutlined /> <ErrorMessage name="FLIGHT_INFOS" />
                                  </div>
                                }
                              </div>
                            ) : null
                          }
                        </div>
                      </div>
                    ) : null
                  }
                  <FieldArray name="CONTRACTS">
                    {
                      () => (
                        <>
                          <Accordion>
                            {
                              this.props.docLinks && this.props.docLinks.length > 0 && _.map(this.props.docLinks, (docLink: LinkModel, index: number) => {
                                return (
                                  <Accordion.Item
                                    key={index}
                                    updateStatus={(openVal: any) => {
                                      // 更新條款狀態
                                      this.setState({
                                        termStatus: commonService.headerClickUpdateTermStatus(openVal, index, this.state.termStatus)
                                      });
                                    }}
                                    isActive={commonService.setPDFOpen(index, this.state.termStatus)}
                                  >
                                    {docLink.URL.includes('.pdf') ? (
                                      <Accordion.Header title={docLink.NAME}>
                                        <button disabled={this.state.isDeclared} type="button" className="review-terms__download-btn" onClick={(event: React.MouseEvent<HTMLButtonElement>) => this.handleDownloadFile(event, docLink.URL, docLink.NAME)} />
                                      </Accordion.Header>
                                    ) : (
                                      <Accordion.Header title={docLink.NAME} link={docLink.URL} />
                                    )}
                                    <Accordion.Content>
                                      {docLink.URL.includes('.pdf') && (
                                        <PDFAllPageViewer
                                          url={docLink.URL}
                                          show={commonService.setPDFOpen(index, this.state.termStatus) || false}
                                          updateStatus={(bottom: any) => {
                                            // 更新條款狀態
                                            this.setState((prev: any) => ({
                                              ...prev,
                                              termStatus: commonService.headerScrollUpdateTermStatus(bottom, index, this.state.termStatus)
                                            }));
                                          }}
                                          checkContracts={values.DECLARED !== YesNo.Yes ? () => {
                                            setFieldValue(`CONTRACTS[${index}].CONTRACT`, true);
                                            apiCommonService.fetchSysTime().then((res: any) => {
                                              setFieldValue(`CONTRACTS[${index}].CONTRACT_CHECKED_TIME`, res);
                                            });
                                          } : () => {}}
                                        />
                                      )}
                                    </Accordion.Content>
                                    <Accordion.Addition>
                                      <div className="element__checkbox-group">
                                        <label htmlFor={`online-ins-checkbox${index + 1}`}>
                                          <div className="element__checkbox">
                                            <Field
                                              disabled={this.state.isDeclared || commonService.setPDFCheckable(index, this.state.termStatus)}
                                              type="checkbox"
                                              name={`CONTRACTS[${index}].CONTRACT`}
                                              id={`online-ins-checkbox${index + 1}`}
                                              onClick={(e: React.MouseEvent<HTMLInputElement>) => {
                                                if (e.currentTarget.checked) {
                                                  apiCommonService.fetchSysTime().then((res: any) => {
                                                    setFieldValue(`CONTRACTS[${index}].CONTRACT_CHECKED_TIME`, res);
                                                  });
                                                }

                                                if (!e.currentTarget.checked) {
                                                  setFieldValue(`CONTRACTS[${index}].CONTRACT_CHECKED_TIME`, null);
                                                  setFieldValue('ALL_CONTRACT_CHECKED', false);
                                                  setFieldValue('ALL_CONTRACT_CHECKED_TIME', null);
                                                }

                                                // 更新狀態
                                                this.setState({
                                                  termStatus: commonService.updateTermStatus(e.currentTarget.checked, index, this.state.termStatus)
                                                });
                                              }}
                                            />
                                            <div className="element__checkbox-btn" />
                                          </div>
                                          <span>審閱條款</span>
                                        </label>
                                      </div>
                                    </Accordion.Addition>
                                  </Accordion.Item>
                                );
                              })
                            }
                          </Accordion>
                        </>
                      )
                    }
                  </FieldArray>
                  <div className="terms">
                    <div className="element__checkbox-group">
                      <label htmlFor="all-checked-checkbox">
                        <div className="element__checkbox">
                          <Field
                            type="checkbox"
                            name="ALL_CONTRACT_CHECKED"
                            id="all-checked-checkbox"
                            disabled={_.some(values.CONTRACTS, (contract: Contract) => !contract.CONTRACT)}
                            onClick={(e: React.MouseEvent<HTMLInputElement>) => {
                              e.currentTarget.checked
                                ? apiCommonService.fetchSysTime().then((res: any) => {
                                  setFieldValue('ALL_CONTRACT_CHECKED_TIME', res);
                                })
                                : setFieldValue('ALL_CONTRACT_CHECKED_TIME', null);
                              if (e.currentTarget.checked) {
                                // 重置已展開的條款
                                this.setState({
                                  termStatus: commonService.resetTermStatus(this.state.termStatus)
                                });
                              }
                            }}
                          />
                          <div className="element__checkbox-btn" />
                        </div>
                        <span className={'agree-all-terms' + (_.some(values.CONTRACTS, (contract: Contract) => !contract.CONTRACT) ? ' grey' : '')}>我已審閱及同意上述條款</span>
                      </label>
                    </div>
                  </div>
                </div>
                <div className="insure-process-fill__controls">
                  {/** <button type="submit" className="element__button element__button--red" disabled={this.state.isDeclared || !(values.CONTRACT1 && values.CONTRACT2 && values.CONTRACT3)}>下一步</button> */}
                  {/** <button type="submit" className="element__button element__button--red">下一步</button> */}
                  <button type="button" className="element__button element__button--red-border" onClick={() => this.props.onEditPlan(this.formikRef.current.values, this.state)}>返回上一頁</button>
                  <button type="submit" className="element__button element__button--red" disabled={this.state.isDeclared || _.some(values.CONTRACTS, (contract: Contract) => !contract.CONTRACT) || !values.ALL_CONTRACT_CHECKED}>下一步</button>
                </div>
                <FormikFocusError />
              </Form>
            )
          }
        </Formik>
      </div>
    );
  }
};

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  setGuardianshipStatementModalVisible: (visible: boolean) => dispatch(setGuardianshipStatementModalVisibleAction(visible))
});

export default connect(mapStateToProps, mapDispatchToProps)(InsureProcessFill1st);
